import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Pre } from 'foundations-components/transitional/components/Pre';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { getLogEventDetail } from 'automation-ui-log-events/utils/logEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EVENT_DETAILS_CONTAINER_MAX_HEIGHT = 200;
const EVENT_DETAILS_CONTAINER_OVERHANG_SIZE = 28;
const LogEventServerResponse = ({
  flowObjectTypeId,
  logEvent
}) => {
  const {
    messageOptions,
    statusCategory
  } = getLogEventDetail(logEvent, flowObjectTypeId);
  const {
    webhookResponseBody,
    webhookStatusCode
  } = messageOptions;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIScrollContainer, {
      maxHeight: EVENT_DETAILS_CONTAINER_MAX_HEIGHT,
      gradientColor: OLAF,
      size: EVENT_DETAILS_CONTAINER_OVERHANG_SIZE,
      children: /*#__PURE__*/_jsx(Pre, {
        use: "code",
        children: /*#__PURE__*/_jsx("div", {
          style: {
            whiteSpace: 'pre-wrap'
          },
          children: webhookResponseBody || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-log-events.logEventServerResponse.defaultMessage"
          })
        })
      })
    }), webhookStatusCode && /*#__PURE__*/_jsx(StatusTag, {
      display: "block",
      use: statusCategory,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-log-events.logEventServerResponse.statusCode",
        options: {
          statusCode: webhookStatusCode
        }
      })
    })]
  });
};
export default LogEventServerResponse;